export enum UserRole {
  GXM_ADMIN = "GXM_ADMIN",
  GXM_USER = "GXM_USER",
  GXM_MANAGER = "GXM_MANAGER",
  LSP_USER = "LSP_USER",
  LSP_MANAGER = "LSP_MANAGER",
  CUSTOMER = "CUSTOMER",
  CUSTOMER_MANAGER = "CUSTOMER_MANAGER",
  SUPER_ADMIN = "SUPER_ADMIN",
}
